import { Link } from 'react-router-dom';

export default function ColoradoSpringsHero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden" style={{ paddingTop: '108px' }}>

      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/8c1517b66d11a59ced21ca441d9ab1e0.jpg')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-ecos-charcoal/92 via-ecos-charcoal/72 to-ecos-charcoal/20"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-ecos-charcoal/50 via-transparent to-ecos-charcoal/70"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-10 pb-24">
        <div className="max-w-3xl">

          {/* Breadcrumb */}
          <div className="flex items-center gap-2 mb-8">
            <Link to="/" className="text-white/40 hover:text-white text-xs transition-colors cursor-pointer">Home</Link>
            <i className="ri-arrow-right-s-line text-white/25 text-xs"></i>
            <Link to="/locations/colorado-springs" className="text-white/40 hover:text-white text-xs transition-colors cursor-pointer">Locations</Link>
            <i className="ri-arrow-right-s-line text-white/25 text-xs"></i>
            <span className="text-ecos-green text-xs font-medium">Colorado Springs</span>
          </div>

          {/* Badge */}
          <div className="inline-flex items-center gap-3 bg-ecos-green/20 border border-ecos-green/40 px-4 py-2 rounded-sm mb-8">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-fill text-ecos-green text-xs"></i>
            </div>
            <span className="text-ecos-green text-xs font-semibold tracking-widest uppercase">Colorado Springs · El Paso County</span>
          </div>

          <h1 className="font-serif text-white font-semibold leading-[1.02] mb-8" style={{ fontSize: 'clamp(2.8rem, 5vw, 4.5rem)' }}>
            Environmental Remediation &amp; Restoration Services in{' '}
            <em className="not-italic text-ecos-gold">Colorado Springs</em>
          </h1>

          <p className="text-white/65 text-lg lg:text-xl leading-relaxed mb-10 max-w-2xl">
            Certified environmental compliance and disaster restoration services for Colorado Springs commercial, industrial, and government clients. Local expertise, federal-grade standards, and 24/7 emergency response.
          </p>

          <div className="flex flex-wrap gap-4 mb-14">
            <Link
              to="/#assessment"
              className="inline-flex items-center gap-2 bg-ecos-green hover:bg-ecos-green-light text-white font-semibold text-sm px-8 py-4 rounded-sm transition-all duration-200 cursor-pointer whitespace-nowrap hover:-translate-y-0.5"
            >
              Request Colorado Springs Assessment
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base"></i>
              </div>
            </Link>
            <a
              href="tel:+18888685420"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/18 border border-white/25 hover:border-white/50 text-white font-medium text-sm px-8 py-4 rounded-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-base text-ecos-green"></i>
              </div>
              Call 888-868-5420
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-8 pt-8 border-t border-white/12">
            {[
              { icon: 'ri-map-pin-line', text: 'Serving Colorado Springs & El Paso County' },
              { icon: 'ri-alarm-warning-line', text: '24/7 Emergency Available' },
              { icon: 'ri-shield-check-line', text: 'EPA / OSHA Certified' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-ecos-green text-sm`}></i>
                </div>
                <span className="text-white/55 text-sm font-medium">{item.text}</span>
              </div>
            ))}
          </div>

        </div>
      </div>

    </section>
  );
}
